import React, { ReactNode, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";
import { classNames } from "@ct-react/core";
import { useScrollLock } from "../../contexts/lockScroll";
import "./pop-up.scss";

type PopUpProps = {
    succeeded?: boolean | null,
    children: ReactNode
    setState:() => void
}

const PopUp = ({
    succeeded = null,
    children,
    setState
}: PopUpProps) => {

    const { lockScroll, unlockScroll } = useScrollLock();

    useEffect(() => {
      lockScroll();
      return () => { unlockScroll(); }
    },[]);

    return(
        <div className="veil">
            <div className="pop-up">
                <FontAwesomeIcon icon={faXmark} onClick={() => setState()} />
                {succeeded != null &&
                <div className="result-icone">
                    <FontAwesomeIcon className={classNames({succeeded: succeeded})} icon={succeeded? faCheck : faXmark}/>
                </div>
                }
                {children}
            </div>
        </div>
    );
};

export default PopUp;
